import { render, staticRenderFns } from "./BaseBgImage.vue?vue&type=template&id=7b3a9787&"
import script from "./BaseBgImage.vue?vue&type=script&lang=js&"
export * from "./BaseBgImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports